export default __webpack_public_path__ + "static/media/Overview-2-d.8d84876f.svg";